export class UpdateTipoServicioRequest {
    
    public id : number = 0
    public descripcion: string = ""
    
}